import Dashboard from "./pages/Dashboard.svelte";
import NotFound from "./pages/NotFound.svelte";
import EventDetailPage from "./pages/EventDetailPage.svelte";
import VisitDetailPage from "./pages/VisitDetailPage.svelte";
import SaalheftPage from "./features/saalheft/pages/SaalheftPage.svelte";
import AudioGuideOverview from "./features/audio/pages/overview/AudioGuideOverview.svelte";
import Test from "./pages/Test.svelte";
import AudioGuideCodeEntry from "./features/audio/pages/overview/AudioGuideCodeEntry.svelte";
import SaaltextPage from "./features/saalheft/pages/SaaltextPage.svelte";
import AudioPageGuide from "./features/audio/pages/player/AudioPageGuide.svelte";
import AudioPagePodcast from "./features/audio/pages/player/AudioPagePodcast.svelte";
import PodcastsOverview from "./features/audio/pages/overview/PodcastsOverview.svelte";
import PodcastEpisodesOverview from "./features/audio/pages/overview/PodcastEpisodesOverview.svelte";
import OnSiteDashboard from "./pages/OnSiteDashboard.svelte";
import HighlightsOverviewPage from "./features/highlights/pages/HighlightsOverviewPage.svelte";
import RestaurantDetailPage from "./pages/RestaurantDetailPage.svelte";
import LivestreamPage from "./features/livestream/pages/LivestreamPage.svelte";
import AdminPage from "./features/admin/pages/AdminPage.svelte";
import AdminSettingsPage from "./features/admin/auth/AdminSettingsPage.svelte";
import LoginPage from "./features/admin/auth/LoginPage.svelte";
import EntityOverviewPage from "./features/admin/pages/EntityOverviewPage.svelte";
import EntityPage from "./features/admin/pages/EntityPage.svelte";
import VideoDetailPage from "./pages/VideoDetailPage.svelte";
import ExplorePage from "./features/highlights/pages/ExplorePage.svelte";
import ContentLibraryPage from "./features/highlights/pages/ContentLibraryPage.svelte";
import AudioGuideBarrier from "./features/audio/guards/AudioGuideBarrier.svelte";
import SocialPage from "./features/social/SocialPage.svelte";
import Impressum from "./pages/Impressum.svelte";

export const routes = {
    "/": Dashboard,
    "/onsite": OnSiteDashboard,
    "/besuch": VisitDetailPage,
    "/restaurant": RestaurantDetailPage,
    // event stuff
    "/event/:id": EventDetailPage,
    "/event/:id/onsite": EventDetailPage,
    "/highlights": HighlightsOverviewPage,
    "/content": ContentLibraryPage,
    "/explore": ExplorePage,
    "/live/:id": LivestreamPage,
    "/video/:id": VideoDetailPage,
    // saalheft/text
    "/saalheft/:id": SaalheftPage,
    "/saaltext/:saalheftId/:id": SaaltextPage,
    // audio guide route tree
    "/audio-guide/:id": AudioGuideOverview,
    "/audio-guide/:id/:trackId": AudioPageGuide,
    "/audio-guide-code/:id": AudioGuideCodeEntry,
    "/audio-guide-entry/:id": AudioGuideBarrier,
    // podcast route tree
    "/podcasts": PodcastsOverview,
    "/podcasts/:id": PodcastEpisodesOverview,
    "/podcasts/:id/:trackId": AudioPagePodcast,
    // socials
    "/social": SocialPage,

    "/admin": AdminPage,
    "/admin/entities/:schemaName": EntityOverviewPage,
    "/admin/entities/:schemaName/:id": EntityPage,
    "/admin/entities/:schemaName/add": EntityPage,
    "/login": LoginPage,
    "/admin/settings": AdminSettingsPage,

    "/impressum": Impressum,

    "/test": Test,
    // Catch-all
    "*": NotFound,
};
